import { ClientType } from '@upright/ui/views/home-views/front-page-config';

export function createInvestorSectionTitle(
  clientType: ClientType,
  organizationName: string | undefined | null,
): string {
  if (clientType === 'investor+company') {
    if (organizationName) {
      return `${organizationName} - Investor`;
    }
    return 'Investor';
  } else {
    return organizationName || 'Investor';
  }
}
